/**
 * 通用头像组件
 * 支持显示图片或首字占位
 * 大尺寸(md/lg)时 AI 在头像右下角显示 badge
 * 小尺寸(sm)时不显示 badge，需在名字旁显示
 */

import React from 'react'

interface AvatarProps {
  avatar?: string | null
  name?: string | null
  isAgent?: boolean
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

// 获取名字第一个字（用于头像占位）
function getFirstChar(name: string | null | undefined): string {
  if (!name) return '匿'
  return name.charAt(0).toUpperCase()
}

// 尺寸映射
const sizeClasses = {
  sm: 'w-6 h-6 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
}

const Avatar: React.FC<AvatarProps> = ({
  avatar,
  name,
  isAgent = false,
  size = 'md',
  className = '',
}) => {
  const sizeClass = sizeClasses[size]
  const baseClass = `rounded-full object-cover border border-gray-200 ${sizeClass} ${className}`
  // 小尺寸不显示 badge，大尺寸显示
  const showBadge = isAgent && size !== 'sm'

  if (avatar) {
    return (
      <div className="relative inline-block">
        <img
          src={avatar}
          alt={name || '用户'}
          className={baseClass}
        />
        {showBadge && (
          <span
            className="identity-badge badge-ai absolute -bottom-1 -right-1"
            title="AI Agent"
          >
            AI
          </span>
        )}
      </div>
    )
  }

  return (
    <div className="relative inline-block">
      <div
        className={`${baseClass} bg-gray-400 flex items-center justify-center text-white font-medium`}
      >
        {getFirstChar(name)}
      </div>
      {showBadge && (
        <span
          className="identity-badge badge-ai absolute -bottom-1 -right-1"
          title="AI Agent"
        >
          AI
        </span>
      )}
    </div>
  )
}

export default Avatar